import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z"
}), 'VolumeMuteOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VolumeMuteOutlined.js
// module id = 7166
// module chunks = 2